import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "/logo-new.png";

const sections = [
  {
    title: 'About CinCin',
    questions: [
      {
        q: 'What is CinCin Events?',
        a: 'CinCin Events is a luxury wedding and brand experience company based in India. Founded by Palak, CinCin specialises in weddings, milestone celebrations, corporate events, real estate launches, brand activations, and exhibitions. The company works with clients across India and with NRI families based in the US, UK, and Australia.'
      },
      {
        q: 'Who founded CinCin Events?',
        a: 'CinCin Events was founded by Palak, an event professional with over a decade of experience across luxury, corporate, and wedding ecosystems. Palak studied Event Management in Sheffield, UK, and built her career working with global luxury brands including Christian Louboutin, Sephora, and COS in Dubai, before working on large-scale experiences for Vogue, YPO, and leading beauty and lifestyle brands in Mumbai. She headed the events vertical at Schbang before founding CinCin.'
      },
      {
        q: 'Where is CinCin Events based?',
        a: 'CinCin Events is based in India and operates across major cities including Delhi, Mumbai, and other destinations nationwide. CinCin also manages destination events and works with international clients planning events in India.'
      },
      {
        q: 'What makes CinCin Events different from other event companies?',
        a: 'CinCin operates as an experience orchestrator rather than a traditional event planner. Every engagement is built around a single standard: nothing is accidental. CinCin combines creative direction with executional precision, managing vendors, logistics, power infrastructure, and production in-house. The company is built for clients who refuse to be generic, whether planning a personal celebration or a brand moment.'
      },
    ]
  },
  {
    title: 'Services',
    questions: [
      {
        q: 'What types of events does CinCin handle?',
        a: 'CinCin handles two broad categories of events. Personal celebrations include weddings, destination weddings, milestone birthdays, anniversaries, intimate gatherings, and proposals. Brand and corporate experiences include product launches, real estate unveilings, brand activations, exhibitions, corporate conferences, and leadership offsites.'
      },
      {
        q: 'Does CinCin do destination weddings?',
        a: 'Yes. CinCin manages destination weddings across India, including multi-day celebrations at heritage properties, resort venues, and private estates. CinCin has experience coordinating all logistics for guests and families travelling from abroad.'
      },
      {
        q: 'Does CinCin manage corporate events and brand activations?',
        a: 'Yes. CinCin has worked on brand experiences for luxury retail, real estate, beauty, and lifestyle brands. Corporate experience includes large-scale activations, product launches, exhibitions, and curated brand showcases. CinCin\'s approach is designed for brands that care about presence, not just visibility.'
      },
      {
        q: 'Does CinCin manage real estate launch events?',
        a: 'Yes. CinCin specialises in real estate launch experiences, creating environments that communicate the value and vision of a property before a single brochure is handed out. CinCin has worked on residential and commercial property launches across India.'
      },
      {
        q: 'Does CinCin handle exhibitions and stalls?',
        a: 'Yes. CinCin designs and manages exhibition spaces, brand stalls, and curated showcases, from gallery-format displays to large-scale industry exhibitions.'
      },
      {
        q: 'What is CinCin\'s approach to event production?',
        a: 'CinCin has an in-house production team and warehouse facility for production of event materials, decor, and structural elements. Every event has a dedicated production head overseeing technical execution. CinCin also specialises in power and load management for large-scale events, using hybrid power systems to ensure zero failure on the day.'
      },
    ]
  },
  {
    title: 'NRI and International Clients',
    questions: [
      {
        q: 'Does CinCin work with NRI clients planning events in India?',
        a: 'Yes. CinCin regularly works with NRI families based in the United States, United Kingdom, and Australia who are planning weddings, milestone celebrations, and private events in India. Remote coordination is a core part of how CinCin operates, not an exception.'
      },
      {
        q: 'How does CinCin manage events for clients who are based outside India?',
        a: 'CinCin takes on full coordination from the first call. The process includes video walkthroughs of venues, regular check-ins via WhatsApp and video call, vendor selection and management handled entirely by CinCin, and detailed progress updates throughout the planning period. Clients typically need to be present only in the final days before the event. By the time they land in India, everything is ready.'
      },
      {
        q: 'Which countries do CinCin\'s international clients come from?',
        a: 'CinCin\'s primary client base is in India and Dubai. CinCin also works with NRI families based in the United States, United Kingdom, and Australia who are planning events in India.'
      },
      {
        q: 'Can NRI clients trust CinCin to manage vendors without being present?',
        a: 'Yes. Vendor management is one of CinCin\'s core strengths. CinCin operates as the central command for all vendor relationships, briefing, coordinating, and holding vendors accountable on the client\'s behalf. Clients do not need to chase vendors, follow up on deliveries, or manage logistics remotely.'
      },
      {
        q: 'How early should NRI clients begin planning with CinCin?',
        a: 'For weddings and large celebrations, CinCin recommends beginning the planning process 6-12 months in advance. For milestone celebrations and private events, 3-6 months is typically sufficient. Early engagement ensures the best venues, vendors, and production resources are available.'
      },
    ]
  },
  {
    title: 'Working With CinCin',
    questions: [
      {
        q: 'How do I get in touch with CinCin?',
        a: 'You can reach CinCin via the contact form at cincin.events, by email, or directly on WhatsApp. WhatsApp is the preferred channel for international clients and for quick conversations.'
      },
      {
        q: 'What information should I share when I first reach out?',
        a: 'It helps to share the type of event, approximate date, location in India, expected number of guests, and where you are currently based. CinCin will schedule a discovery call to understand your vision in detail before any formal proposal is made.'
      },
      {
        q: 'Does CinCin take on a limited number of events?',
        a: 'Yes. CinCin deliberately limits the number of events it takes on at any given time to ensure every client receives the full attention of the team. Early inquiry is recommended for peak wedding season dates (October through February).'
      },
      {
        q: 'What cities in India does CinCin operate in?',
        a: 'CinCin is based in Delhi and operates across India, including Mumbai, Jaipur, Udaipur, Goa, and other major event destinations. CinCin also manages events at destination venues including heritage properties and resort locations.'
      },
      {
        q: 'Does CinCin provide a visual concept before signing?',
        a: 'Yes. Every CinCin proposal includes a visual mood board and concept developed by the in-house design team. Clients receive a designed look-book reflecting the proposed aesthetic and experience before the engagement begins.'
      },
    ]
  },
  {
    title: 'About the Brand',
    questions: [
      {
        q: 'What does CinCin mean?',
        a: 'CinCin is the sound of celebration, the clink of glasses, the moment of joy. The name captures the spirit of the brand: every event is a moment worth marking, and worth doing right.'
      },
      {
        q: 'What is CinCin\'s design philosophy?',
        a: 'CinCin believes the most meaningful celebrations are not the loudest, but the most intentional. Every space, every detail, and every moment is designed with purpose, not to impress, but to stay with you.'
      },
      {
        q: 'Is CinCin active on Instagram?',
        a: 'Yes. CinCin is active on Instagram at @cincin.in, where Palak shares behind-the-scenes content, event work, and her perspective on design and celebration.'
      },
    ]
  },
];

export default function FaqPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'FAQ | CinCin Events';

    // Set meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Answers to common questions about CinCin Events — luxury weddings, corporate experiences, NRI event planning, and working with us from abroad.'
      );
    }

    // Ensure robots tag
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'index, follow';
  }, []);

  return (
    <div className="min-h-screen bg-[#EFEAE6]">
      {/* Minimal header */}
      <div className="py-6 px-6 md:px-16 lg:px-24">
        <div className="max-w-[1200px] mx-auto">
          <Link to="/" data-testid="faq-home-link">
            <img src={LOGO_URL} alt="CinCin Events" className="h-14 md:h-16 w-auto" />
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 md:px-16 lg:px-24 pb-20 md:pb-32">
        <div className="max-w-[720px] mx-auto md:mx-0 md:ml-[calc((100%-1200px)/2+0px)] lg:ml-[calc((100%-1200px)/2+0px)]">
          <div className="max-w-[1200px]">
            {/* Page label */}
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C]/60 font-light mt-8 md:mt-12">
              Frequently Asked Questions
            </p>
            <div className="w-10 h-[1px] bg-[#D8B4A0] mt-4 mb-16 md:mb-24" />

            {/* Sections */}
            <div className="space-y-16 md:space-y-24">
              {sections.map((section) => (
                <div key={section.title}>
                  <p className="text-[10px] tracking-[0.25em] uppercase text-[#8C8C8C]/50 font-light mb-10">
                    {section.title}
                  </p>
                  <div className="space-y-10 md:space-y-12">
                    {section.questions.map((item) => (
                      <div key={item.q}>
                        <p
                          className="text-[15px] leading-[1.6] text-[#0A0A0A]/75 font-normal"
                          style={{ letterSpacing: '0.2px' }}
                        >
                          {item.q}
                        </p>
                        <p
                          className="mt-3 text-[13px] leading-[1.9] text-[#0A0A0A]/45 font-light"
                          style={{ letterSpacing: '0.3px' }}
                        >
                          {item.a}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Back link */}
            <div className="mt-20 md:mt-28">
              <Link
                to="/"
                className="text-[10px] tracking-[0.18em] uppercase text-[#8C8C8C]/50 font-light hover:text-[#0A0A0A]/50 transition-colors duration-300"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Minimal footer */}
      <div className="border-t border-[#0A0A0A]/6 mx-6 md:mx-16 lg:mx-24" />
      <div className="py-6 px-6 md:px-16 lg:px-24 text-center">
        <p className="text-[9px] tracking-[0.12em] text-[#8C8C8C]/40 font-light">
          &copy; 2026 CinCin Events. All rights reserved.
        </p>
      </div>
    </div>
  );
}
